import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = { class: "flex flex-row justify-between items-center py-2 pr-4 pl-6" }
const _hoisted_2 = { class: "flex flex-row items-center gap-2" }
const _hoisted_3 = { class: "bg-gray-lp-1200 py-2 px-4 h-full overflow-y-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CargoV2EditHeaderTitle = _resolveComponent("CargoV2EditHeaderTitle")!
  const _component_CargoV2EditHeaderActions = _resolveComponent("CargoV2EditHeaderActions")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/cargo-v2/create" }, {
          default: _withCtx(() => [
            _createVNode("img", {
              src: _imports_0,
              class: "w-6 cursor-pointer",
              alt: _ctx.$t('cargoV2.create.common.backAlt')
            }, null, 8, ["alt"])
          ]),
          _: 1
        }),
        _createVNode(_component_CargoV2EditHeaderTitle, {
          cargoType: _ctx.cargoType,
          origin: _ctx.detailData.originCode,
          destination: _ctx.detailData.destinationCode,
          departureDate: _ctx.formattedDepartureDate
        }, null, 8, ["cargoType", "origin", "destination", "departureDate"])
      ]),
      _createVNode(_component_CargoV2EditHeaderActions, {
        originCityCode: _ctx.detailData.originCode,
        destinationCityCode: _ctx.detailData.destinationCode,
        disabledSelectSchedule: _ctx.disabledSelectSchedule,
        disabledBooking: _ctx.disabledBooking,
        disabledChangeTransport: _ctx.disabledChangeTransport,
        showSelectSchedule: _ctx.showSelectSchedule,
        onSelectModa: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change-cargo-type', $event))),
        onBooking: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('booking'))),
        onSelectSchedule: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('select-schedule')))
      }, null, 8, ["originCityCode", "destinationCityCode", "disabledSelectSchedule", "disabledBooking", "disabledChangeTransport", "showSelectSchedule"])
    ]),
    _createVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 64))
}